import { useEffect, useState } from "react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Input } from "@/components/ui/input";
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "@/components/ui/select";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { Panel, PageHead, StatusBadge, Empty } from "@/components/common";
import { TeamTree } from "@/components/TeamTree";
import { useApi, fmtDate } from "@/lib/api";

const TeamList = ({ members }) => {
  const [q, setQ] = useState("");
  const [st, setSt] = useState("all");
  const rows = members.filter((m) => (st === "all" || m.status === st) && `${m.name} ${m.email} ${m.referral_code}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <>
      <div className="mb-4 flex flex-col gap-3 sm:flex-row">
        <Input data-testid="team-search-input" placeholder="Search name, email or code" value={q} onChange={(e) => setQ(e.target.value)} />
        <Select value={st} onValueChange={setSt}>
          <SelectTrigger className="sm:w-48" data-testid="team-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            {["all", "active", "pending", "inactive"].map((s) => <SelectItem key={s} value={s} data-testid={`team-filter-${s}`}>{s[0].toUpperCase() + s.slice(1)}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {rows.length === 0 ? <Empty testId="team-list-empty" text="No members match." /> : (
        <Table data-testid="team-list-table">
          <TableHeader><TableRow><TableHead>Member</TableHead><TableHead>Code</TableHead><TableHead>Level</TableHead><TableHead>Joined</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
          <TableBody>
            {rows.map((m) => (
              <TableRow key={m.user_id} data-testid={`team-row-${m.referral_code}`}>
                <TableCell><p className="text-white">{m.name}</p><p className="text-xs text-slate-500">{m.email}</p></TableCell>
                <TableCell className="font-mono text-xs">{m.referral_code}</TableCell>
                <TableCell className="font-mono">L{m.level}</TableCell>
                <TableCell className="text-xs text-slate-400">{fmtDate(m.created_at)}</TableCell>
                <TableCell><StatusBadge status={m.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </>
  );
};

export default function Team() {
  const api = useApi();
  const [data, setData] = useState(null);
  useEffect(() => { api("get", "/me/team").then(setData); }, [api]);
  return (
    <div data-testid="team-page">
      <PageHead label="Genealogy" title="My Team">
        {data && <p className="font-mono text-sm text-slate-400" data-testid="team-total">{data.members.length} members</p>}
      </PageHead>
      <Panel>
        {!data ? <p className="text-sm text-slate-500">Loading…</p> : (
          <Tabs defaultValue="tree">
            <TabsList className="mb-6"><TabsTrigger value="tree" data-testid="team-tab-tree">Tree</TabsTrigger><TabsTrigger value="list" data-testid="team-tab-list">List</TabsTrigger></TabsList>
            <TabsContent value="tree"><TeamTree root={data.root} members={data.members} /></TabsContent>
            <TabsContent value="list"><TeamList members={data.members} /></TabsContent>
          </Tabs>
        )}
      </Panel>
    </div>
  );
}
